import React, { FC, ReactNode } from 'react';

import styles from './TitleModal.module.scss';

interface TitleProps {
  children: ReactNode;
}

export const TitleModal: FC<TitleProps> = ({ children }) => {
  return (
    <h1
      className={styles.title}
      style={{
        fontSize: '20px',
        lineHeight: 0,
        marginBottom: '40px',
      }}
    >
      {children}
    </h1>
  );
};
